var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDriveFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39158 6.97953e-08H4.50316C3.39302 -0.00023284 2.3643 0.582471 1.79368 1.53474L0.448421 3.78947C0.154784 4.27996 -0.000200011 4.84096 1.93718e-07 5.41263V17.0526C1.93718e-07 18.7967 1.41384 20.2105 3.15789 20.2105H20.8421C22.5862 20.2105 24 18.7967 24 17.0526V6.31579C24 4.57173 22.5862 3.15789 20.8421 3.15789H13.4274L12.3158 1.50316C11.6388 0.561872 10.5511 0.00275441 9.39158 6.97954e-08V6.97953e-08Z",
    fill: "#0060FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriveFolder);
export default __webpack_public_path__ + "static/media/ic-drive-folder.3a1132c4666b7e2715b83a04955bdba2.svg";
export { ForwardRef as ReactComponent };